export enum Constant {
    access_token = "access_token",
    refresh_token = "refresh_token",
    user = "user",
    seller = "seller",



}

export enum StorageKeys {
    categories = "buypass-categories",
    productFormData = "productform-productData",
    productCategoryForm = "productform-categoryForm",
}